/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import Vue from 'vue';

import { resolveRelations, loadItems } from '@/store/helpers';
import teamService from '@/services/team';
import monitorService from '@/services/monitor';
import incidentService from '@/services/incident';

const state = {
    byId: {},
    allIds: [],
    teamIds: [], // Used to hold a team's incidents
    monitorIds: [], // Used to hold a monitors' incidents
};

const getters = {
    // Return a single article with the given id.
    find: (state, _, __, rootGetters) => id =>
        // Swap ID referenes with the resolved author objects.
        resolveRelations(state.byId[id], ['monitor'], rootGetters),
    // Return a list of incidents in the order of `allIds`.
    list: (state, getters) => state.allIds.map(id => getters.find(id)),
    team: (state, getters) => state.teamIds.map(id => getters.find(id)),
    monitor: (state, getters) => state.monitorIds.map(id => getters.find(id)),
};

const actions = {
    load: async ({ commit, rootGetters }, param) => {
        const items = await teamService.getIncidents(rootGetters['team/id'], param.filter || {}, param.pagination || {});
        loadItems(commit, items, ['monitor'], 'addTeam');
        return items.meta;
    },
    loadById: async ({ commit }, incidentId) => {
        console.log('loadById action with incidentId', incidentId);
        const incident = await incidentService.getById(incidentId);
        incident.data = new Array(incident.data); // convert data intro an array of one element
        loadItems(commit, incident, ['monitor'], 'add');
        return incident.meta;
    },
    loadMonitorIncidents: async ({ commit }, param) => {
        const items = await monitorService.getIncidents(param.id, param.pagination || {});
        commit('clearMonitor');
        loadItems(commit, items, [], 'addMonitor');
        return items.meta;
    },
    // Acknowledge
    loadByHash: async ({ commit }, hash) => {
        console.log('loadByHash action with hash', hash);
        const incident = await incidentService.getByHash(hash);
        incident.data = new Array(incident.data); // convert data intro an array of one element
        loadItems(commit, incident, ['monitor'], 'add');
        return incident.meta;
    },
    // Persisting
    acknowledge: async ({ dispatch }, id) => incidentService.acknowledge(id)
        .then(() => dispatch('loadById', id)),
    acknowledgeHashed: async ({ dispatch }, params) => incidentService.acknowledgeHashed(params)
        .then(() => dispatch('loadByHash', `${params.incidentId}-${params.incidentHash}`)),
};

const mutations = {
    // refactor these into a simpler helper
    add: (state, item) => {
        Vue.set(state.byId, item.id, item);
        if (state.allIds.includes(item.id)) return;
        state.allIds.push(item.id);
    },
    addTeam: (state, item) => {
        Vue.set(state.byId, item.id, item);
        if (state.teamIds.includes(item.id)) return;
        state.teamIds.push(item.id);
    },
    clearMonitor: (state) => {
        state.monitorIds = [];
    },
    addMonitor: (state, item) => {
        Vue.set(state.byId, item.id, item);
        if (state.monitorIds.includes(item.id)) return;
        state.monitorIds.push(item.id);
    },
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
